import { z } from 'zod';

export const ActionItemFormSchema = z
  .object({
    id: z.string(),
    title: z.string(),
    description: z.string(),
    internalNote: z.string().optional(),
    assignee: z.object({ id: z.string(), name: z.string() }),
    // D7: recipient is OPTIONAL — the Figma asterisk marking it required is a spec error.
    // Nullable covers the explicit "Internal only (no fabricator)" affordance.
    fabricator: z
      .object({ id: z.string(), name: z.string() })
      .nullable()
      .optional(),
    // Fabricator USERS the item is addressed to — required (>= 1) once a fabricator is chosen,
    // since a fabricator user only sees items they are a recipient of.
    recipients: z.array(z.object({ id: z.string(), name: z.string() })).optional(),
  })
  .superRefine((data, ctx: any) => {
    if (!data.title?.trim()) {
      ctx.addIssue({
        path: ['title'],
        message: 'This field is required',
        code: 'custom',
      });
    }

    if (!data.description?.trim()) {
      ctx.addIssue({
        path: ['description'],
        message: 'This field is required',
        code: 'custom',
      });
    }

    if (!data.assignee?.id) {
      ctx.addIssue({
        path: ['assignee'],
        message: 'This field is required',
        code: 'custom',
      });
    }

    if (data.fabricator?.id && !(data.recipients?.length)) {
      ctx.addIssue({
        path: ['recipients'],
        message: 'Select at least one recipient',
        code: 'custom',
      });
    }
  });
